 /**
  * Adjust resourcelib_tag URLs

jQuery(function($){
    var page_uri = new URI();
    var page_qs = page_uri.search(true);
    $('.resourcelib-taxonomy__term-link', '.resourcelib-taxonomy--resourcelib_tag').each(function(){
        var link_uri = new URI(this);
        var link_qs = link_uri.search(true);
        link_uri.setSearch(page_qs);
        link_uri.setSearch(link_qs);
        link_qs = link_uri.search(true);
        link_uri.search('');
        var link_keys = [];
        $.each(link_qs, function(k, v){
            link_keys.push(k);
        });
        $.each(link_keys.sort(),function(i, v){
            link_uri.setSearch(v, link_qs[v]);
        });
        this.href = link_uri.toString();
    });
});
  */

/**
 * Element.closest Polyfill
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
 */
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;
        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}
(function(){
    // build query in js
    // send params and build query in plugin

    // js needs to keep track of current query/params
    // js needs to be multi purpose and not need changing every time a taxonomy is added

    // tax[resourcelib_category]=customers-use-cases&tax[resourcelib_tag]=video&paged=2

    // tax_query[0][taxonomy]=resourcelib_category&tax_query[0][slug]=customers-use-cases

    // post_type=mdresourcelib&paged=3&tax[resourcelib_category]

    /*document.querySelector('.resourcelib-navigation').addEventListener('click', function(e){
        //if (!e.target.matches('.menu-link')) return;
        if (e.target.matches('.menu-link')) {
            e.preventDefault();
            var linkElem = e.target;
            var navigation_container = this;

            //
            var selector = navigation_container.getAttribute('data-posts-selector');
            var posts_container = document.querySelector(selector ? selector : '.resourcelib-posts');
            var query =  JSON.parse(posts_container.getAttribute('data-query'));

            // get closest data-taxonomy
            var itemsElem = linkElem.closest('[data-taxonomy]');
            var taxonomy = itemsElem.getAttribute('data-taxonomy');
            console.log(taxonomy);


            //console.log(query);
        }

    }, false);*/

    //var postsElem = document.querySelector('.resourcelib-posts');
    //var paged = posts_container.getAttribute('data-paged');
    //var maxNumPages = postsElem.getAttribute('data-max-num-pages');

    // delegate event
    var paginationElem = document.querySelector('.resourcelib-pagination');
    if (paginationElem) paginationElem.addEventListener('click', function(e){
        if (e.target.matches('.more')) {
            e.preventDefault();
            var posts_selector = paginationElem.getAttribute('data-posts-selector');
            var posts_container = document.querySelector(posts_selector ? posts_selector : '.resourcelib-posts');
            var query =  JSON.parse(posts_container.getAttribute('data-query'));

            var paged = posts_container.getAttribute('data-paged');
            var max_num_pages = posts_container.getAttribute('data-max-num-pages');
            paged++;
            query.paged = paged;
            posts_container.setAttribute('data-paged', paged);

            posts_container.setAttribute('data-query', JSON.stringify(query));
            //console.log(query);
            // ajax
            var req = new XMLHttpRequest();
            req.open('POST', resourcelib.ajax_url + '?action=resourcelib_get_posts&_ajax_nonce=' + resourcelib.get_posts_nonce, true);
            req.setRequestHeader('Content-type', 'application/json');
            req.onload = function() {
                // create virtual element
                var placeholder = document.createElement('div');
                placeholder.innerHTML = req.responseText;
                var postsElem = placeholder.querySelector('.resourcelib-posts');
                // use inner html or all
                //posts_container.innerHTML = '';
                posts_container.insertAdjacentHTML('beforeend', postsElem ? postsElem.innerHTML : req.responseText);
                // set "end" (e.g. no more pages)
                if ( paged >= max_num_pages) paginationElem.className += ' end';
            };
            // network level error
            // req.onerror = function() {}
            req.send(JSON.stringify(query));
        }
    }, false);
})();


/**
 * Watch "nooz-posts" container element for size changes.

(function(){
    var smCardMinWidth = 240 + 30;
    var mdCardMinWidth = 250 + 30;
    var lgCardMinWidth = 310 + 30;

    var sm = 551;
    var views = document.getElementsByClassName('resourcelib-posts');
    function removeClassName(el, className) {
        var arr = el.className.split(' ');
        var idx = arr.indexOf(className);
        if (idx === -1) return;
        arr.splice(idx, 1);
        el.className = arr.join(' ');
    }
    function addClassName(el, className) {
        if (el.className.split(' ').indexOf(className) > -1) return;
        el.className += ' ' + className;
    }
    var smCardCountAvailable = 1;
    var mdCardCountAvailable = 1;
    var lgCardCountAvailable = 1;
    function setBreakpoint() {
        for (var i = 0; i < views.length; i++) {
            var el = views[i];
            var rect = el.getBoundingClientRect();

            var mdCardCount = Math.floor(rect.width/mdCardMinWidth);
            spaceAvailable = el.getAttribute('data-md-items');
            if (spaceAvailable != mdCardCount) {
                //spaceAvailable = mdCardCount;
                //for (var j=0; j<=5; j++) removeClassName(el, 'resourcelib-posts--md-i' + j);
                //addClassName(el, 'resourcelib-posts--md-i' + mdCardCount);
                el.setAttribute('data-space-md', mdCardCount);
            }

            var lgCardCount = Math.floor(rect.width/lgCardMinWidth);
            spaceAvailable = el.getAttribute('data-lg-items');
            if (spaceAvailable != lgCardCount) {
                //lgCardCountAvailable = lgCardCount;
                //for (var j=0; j<=5; j++) removeClassName(el, 'resourcelib-posts--lg-i' + j);
                //addClassName(el, 'resourcelib-posts--lg-i' + lgCardCount);
                el.setAttribute('data-space-lg', lgCardCount);
            }
        }
    }
    // respond to window resize event
    window.addEventListener('resize', setBreakpoint);
    // respond to user events
    document.body.addEventListener('click', function(e){
        // wait for other behavior to complete
        setTimeout(setBreakpoint, 200);
    });
    setBreakpoint();
})();
 */
